import { useState } from 'react'
import type { FallbackProps } from 'react-error-boundary'
import { Button } from '@/react/ui/button'

/** ErrorBoundary.vue's face: the message, Try Again, and the stack on request. */
export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const [showDetails, setShowDetails] = useState(false)
  const err = error instanceof Error ? error : new Error(String(error))
  return (
    <div className="error-boundary" role="alert" data-testid="error-fallback">
      <div className="scvc-alert">
        <div className="scvc-alert__body">
          <div className="scvc-alert__title">
            <i className="mdi mdi-alert-circle scvc-icon" aria-hidden="true" />
            Something went wrong
          </div>
          <div className="scvc-alert__text">
            {err.message || 'An unexpected error occurred. Please try refreshing the page.'}
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={resetErrorBoundary}>
          Try Again
        </Button>
      </div>
      {showDetails && <pre className="error-stack">{err.stack || `${err.name}: ${err.message}`}</pre>}
      <div className="mt-4">
        <Button variant="outline" size="sm" onClick={() => setShowDetails((v) => !v)}>
          {showDetails ? 'Hide' : 'Show'} Details
        </Button>
      </div>
    </div>
  )
}
